// src/components/CookieConsent.jsx
import React, { useState, useEffect } from "react";
import { Box, Text, Button, Heading } from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Verifica si el usuario ya aceptó las cookies
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "true");
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      bg="gray.800"
      color="white"
      p={4}
      zIndex="alert"
      boxShadow="md"
    >
      <Text mb={3} fontSize="sm" color="gray.200">
        {t('cookies_intro')}
      </Text>

      <Heading
        as="h4"
        size="sm"
        mb={1}
        color="teal.200"
        fontWeight="bold"
        letterSpacing="wide"
        textTransform="uppercase"
      >
        {t('cookies_section1_title')}
      </Heading>
      <Text mb={3} fontSize="sm" color="gray.200">
        {t('cookies_section1_intro')}
      </Text>
      <Text mb={2} fontSize="sm" color="gray.200" pl={4}>
        • <strong>{t('cookies_item1_title')}</strong> {t('cookies_item1_desc')}
      </Text>
      <Text mb={2} fontSize="sm" color="gray.200" pl={4}>
        • <strong>{t('cookies_item2_title')}</strong> {t('cookies_item2_desc')}
      </Text>
      <Text mb={2} fontSize="sm" color="gray.200" pl={4}>
        • <strong>{t('cookies_item3_title')}</strong> {t('cookies_item3_desc')}
      </Text>
      <Text mb={2} fontSize="sm" color="gray.200" pl={4}>
        • <strong>{t('cookies_item4_title')}</strong> {t('cookies_item4_desc')}
      </Text>
      <Text mb={3} fontSize="sm" color="gray.200" pl={4}>
        • <strong>{t('cookies_item5_title')}</strong> {t('cookies_item5_desc')}
      </Text>

      <Heading
        as="h4"
        size="sm"
        mb={1}
        color="teal.200"
        fontWeight="bold"
        letterSpacing="wide"
        textTransform="uppercase"
      >
        {t('cookies_section2_title')}
      </Heading>
      <Text mb={3} fontSize="sm" color="gray.200">
        {t('cookies_section2_text')}
      </Text>

      <Heading
        as="h4"
        size="sm"
        mb={1}
        color="teal.200"
        fontWeight="bold"
        letterSpacing="wide"
        textTransform="uppercase"
      >
        {t('cookies_section3_title')}
      </Heading>
      <Text mb={3} fontSize="sm" color="gray.200">
        {t('cookies_section3_text')}
      </Text>

      <Text mb={2} fontSize="sm" color="gray.200">
        {t('cookies_footer')}
      </Text>
      <Button size="sm" colorScheme="teal" onClick={handleAccept}>
        {t('cookies_accept')}
      </Button>
    </Box>
  );
};

export default CookieConsent;
